import find from 'lodash/find';

import CompanyPhoneNumber from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import companyPhoneNumbersResource from 'src/actions/companyPhoneNumber/companyPhoneNumbersResource';
import { isLoadingStatus, useResourceValues } from 'src/presentation/hooks/useResource';
import { PhoneNumberCapability } from 'src/actions/availableNumbers/availableNumbersResource';
import useConfigurationResource from './useConfigurationResourceByType';

export default function useFetchPhoneNumbers(entityType: PhoneNumberCapability) {
  const { values: entries } = useConfigurationResource(entityType);

  const { values: companyEntities, loadingState: companyLoading } = useResourceValues(companyPhoneNumbersResource);

  const isLoading = isLoadingStatus(companyLoading);
  const values = companyEntities.filter(
    (companyEntity: CompanyPhoneNumber) =>
      !find(entries, entry => entry.number === companyEntity.phoneNumber) &&
      companyEntity.capabilities.includes(entityType)
  );

  return { isLoading, values };
}
